<template>
  <div class="box">
    <div class="mngmtLinks mx-4 my-6">
      <div class="mngmtLinks__info d-flex align-center">
        <div class="mngmtLinks__info-icon d-flex"></div>
        <div class="mngmtLinks__info-elementInfo">
          <h6 class="text-gray-light">{{ elementType }}</h6>
          <span class="text-mngmtLink text-semibold">{{ elementName }}</span>
        </div>
      </div>
      <v-textarea
        :disabled="!canEdit"
        label="Link bearbeiten"
        v-model="mngmtLink.text"
        class="mngmtLinks__mngmtLink"
      ></v-textarea>
      <v-btn
        v-if="canEdit"
        text
        @click="mngmtLink.text = ''"
        block
        color="gray_3"
        class="mb-2"
      >
        <v-icon>mdi-close-circle</v-icon>Text zurücksetzen
      </v-btn>
    </div>
    <div v-if="canEdit" class="newmngmtLink">
      <div>
        <v-btn
          @click="saveElementMngmtLink"
          block
          color="primary"
          elevation="0"
        >
          Speichern
        </v-btn>
      </div>
    </div>
    <v-snackbar :timeout="snackTimeout" v-model="snackbar">
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>
import mngmtLinkService from "./mngmtLink-service";
import { decodeElementByName } from "@/components/util";

export default {
  components: {},
  props: {
    uuid: String,
    elementId: String,
    element: Object,
    canEdit: Boolean,
  },
  data: function () {
    return {
      mngmtLink: {
        text: "abc",
      },
      snackbar: false,
      snackTimeout: 2200,
      snackbarText: "Link wurde erfolgreich gespeichert!",
    };
  },
  mounted: function () {
    this.retrieveMngmtLink();
  },
  watch: {
    elementId: function (val) {
      this.retrieveMngmtLink();
    },
  },
  computed: {
    elementType() {
      if (!this.element || !this.element.businessObject) return "";
      return this.element.businessObject.$type.split(":")[1];
    },
    elementName() {
      if (!this.element || !this.element.businessObject) return "";
      let regex = /^(.*)_(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])/i;
      var name = this.element.businessObject.name
        ? this.element.businessObject.name
        : this.element.id;
      if (regex.test(name)) return "";
      return name;
    },
  },
  methods: {
    decodeElementByName: decodeElementByName,
    saveElementMngmtLink() {
      mngmtLinkService
        .saveLink(this.uuid, this.elementId, this.mngmtLink.text)
        .then(() => {
          this.retrieveMngmtLink();
          this.$emit("refresh");
        });
      this.snackbar = true;
    },
    retrieveMngmtLink() {
      this.mngmtLink = {
        text: null,
      };
      mngmtLinkService
        .getMngmtLink(this.uuid, this.elementId)
        .then((result) => {
          if (result.data != "" && result.data != null) {
            this.mngmtLink = result.data;
          }
        });
    },
    highlightLinks(text) {
      // Regular expression to match URLs
      const urlRegex = /((http|https):\/\/[^\s]+)/g;

      // Replace URLs with anchor tags
      const highlightedText = text.replace(
        urlRegex,
        '<a href="$&" target="_blank">$&</a>'
      );

      return highlightedText;
    },
  },
};
</script>
<style lang="scss" scoped>
.mngmtLinks,
.newmngmtLink {
  position: absolute;
}
.mngmtLinks {
  top: 0;
  left: 0;
  right: 0;
  overflow-y: auto;
  &__info {
    flex-wrap: wrap;
    &-icon {
      width: 40%;
      height: 40%;
      max-height: 150px;
      margin: 0 auto;
    }
    &-elementInfo {
      width: 60%;
    }
  }
}
:deep .mngmtLinks__mngmtLink .v-text-field__slot {
  label {
    top: 10px;
    left: 10px;
    padding-left: 10px;
  }
  textarea {
    background-color: var(--background-shade) !important;
    border-radius: 10px 10px 0 0;
    padding: 10px 10px 10px 10px;
  }
}
.newmngmtLink {
  bottom: 0;
  right: 0;
  left: 0;
  margin: 10px;
}
.box {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
}
.sub {
  font-size: 0.7rem;
}
</style>